import { Flex } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaAngleRight, FaPlus } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../../components/Button'
import { WhiteBox } from '../../../../components/WhiteBox'
import { iPutQuestaoCaixaSelecao, iPutQuestaoFlexivel, iQuestaoFlexivel } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import { Body } from '../../../Layouts/Body'
import { Questao } from './Components/Questao'
import { CaixaDeSelecao } from './Components/Questao/Components/CaixaDeSelecao'
import { Discursiva } from './Components/Questao/Components/Discursiva'
import { MultiplaEscolha } from './Components/Questao/Components/MultiplaEscolha'

type iParam = {
  pesquisaId: string
  trilhaId: string
  processoId: string
}

interface iForm {
  nomePesquisa: string
  questoes: iQuestaoFlexivel[]
}

export const FormularioPesquisaInterna: React.FC = () => {
  const param = useParams<iParam>()
  const nav = useNavigate()
  const { pathname } = useLocation()

  const [Formulario, setFormulario] = useState<iForm>()

  function getFormulario(): void {
    appApi.get(`PesquisaInterna/${param.pesquisaId as string}/Formulario`)
      .then(res => setFormulario(res.data))
      .catch(err => console.log(err))
  }

  function AdicionarQuestao(): void {
    appApi.post(`PesquisaInternaQuestao/${param.pesquisaId as string}`)
      .then(getFormulario)
      .catch(err => console.log(err))
  }

  function UpdatePropsEmComumQuestao(questao: iPutQuestaoFlexivel, id: string): void {
    appApi.put(`PesquisaInternaQuestao/${param.pesquisaId as string}/questao/${id}`, questao)
      .then(() => {
        if (Formulario !== undefined) {
          const filtrado = { ...Formulario }
          const pos = filtrado.questoes.findIndex(e => e.id === id)
          if (pos !== -1) {
            filtrado.questoes[pos].enunciado = questao.enunciado
            filtrado.questoes[pos].tipo = questao.tipo
            filtrado.questoes[pos].obrigatoria = questao.obrigatoria
            setFormulario(filtrado)
          }
        }
      })
      .catch(err => console.log(err))
  }

  function UpdateCaixaDeSelecao(questaoId: string, form: iPutQuestaoCaixaSelecao): void {
    appApi.put(`PesquisaInternaQuestao/${param.pesquisaId as string}/questao/${questaoId}/CaixaSelecao`, form)
      .then(() => {
        if (Formulario !== undefined) {
          const filtrado = { ...Formulario }
          const pos = filtrado.questoes.findIndex(e => e.id === questaoId)
          if (pos !== -1) {
            filtrado.questoes[pos].maxCaixaSelecao = form.maxCaixaSelecao
            filtrado.questoes[pos].minCaixaSelecao = form.minCaixaSelecao
            setFormulario(filtrado)
          }
        }
      })
      .catch(err => console.log(err))
  }

  function DeletarQuestao(id: string): void {
    appApi.delete(`PesquisaInternaQuestao/${param.pesquisaId as string}/questao/${id}`)
      .then(() => {
        if (Formulario !== undefined) {
          const filtrado = { ...Formulario }
          filtrado.questoes = filtrado.questoes.filter(e => e.id !== id)
          setFormulario(undefined)
          setFormulario(filtrado)
        }
      })
      .catch(err => console.log(err))
  }

  function DuplicarQuestao(id: string): void {
    appApi.post(`PesquisaInternaQuestao/${param.pesquisaId as string}/questao/${id}/Duplicar`)
      .then(getFormulario)
      .catch(err => console.log(err))
  }

  function AdicionarAlternativa(id: string): void {
    appApi.post(`PesquisaInternaQuestao/${param.pesquisaId as string}/questao/${id}/Alternativa`)
      .then(getFormulario)
      .catch(err => console.log(err))
  }

  function RemoverAlternativa(questaoId: string, alternativaId: string): void {
    appApi.delete(`PesquisaInternaQuestao/${param.pesquisaId as string}/questao/${questaoId}/Alternativa/${alternativaId}`)
      .then(getFormulario)
      .catch(err => console.log(err))
  }

  function UpdateTextoAlternativa(questaoId: string, alternativaId: string, texto: string): void {
    appApi.put(`PesquisaInternaQuestao/${param.pesquisaId as string}/questao/${questaoId}/Alternativa/${alternativaId}`, { texto: texto })
      .then(() => {
        if (Formulario !== undefined) {
          const filtrado = { ...Formulario }
          const pos = filtrado.questoes.findIndex(e => e.id === questaoId)
          if (pos !== -1) {
            const posAlternativa = filtrado.questoes[pos].alternativas.findIndex(e => e.id === alternativaId)
            if (posAlternativa !== -1) {
              filtrado.questoes[pos].alternativas[posAlternativa].texto = texto
              setFormulario(filtrado)
            }
          }
          console.log(filtrado)
        }
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getFormulario()
  }, [])

  return (
    <Body>
      <WhiteBox>
        <Flex>
          <h1>Jornada {'>'} Pesquisas internas {'>'} {Formulario?.nomePesquisa}</h1>
        </Flex>
        <Flex margin={'2rem 0'}>
          <h3>Adicione as perguntas para o formulário</h3>
        </Flex>

        {
          (Formulario) && (
            <Flex flexDirection={'column'} gap={'2rem 0rem'}>
              {
                Formulario?.questoes.map((e) => {
                  return (
                    <Questao
                      key={e.id}
                      onDelete={DeletarQuestao}
                      onUpdate={UpdatePropsEmComumQuestao}
                      onDuplicar={DuplicarQuestao}
                      questao={e}
                    >
                      {
                        e.tipo === 0
                          ? <MultiplaEscolha
                            onCreate={AdicionarAlternativa}
                            onDelete={RemoverAlternativa}
                            onUpdate={UpdateTextoAlternativa}
                            questao={e}
                          />
                          : e.tipo === 1
                            ? <Discursiva
                              questao={e} />
                            : <CaixaDeSelecao
                              onCreate={AdicionarAlternativa}
                              onDelete={RemoverAlternativa}
                              onUpdate={UpdateTextoAlternativa}
                              onUpdateMaxMin={UpdateCaixaDeSelecao}
                              questao={e}
                            />
                      }
                    </Questao>
                  )
                })
              }
            </Flex>
          )
        }

        <Flex margin={'2rem 0'}>
          <Button VarColor='Azul' onClick={AdicionarQuestao} rightIcon={<FaPlus />}>Adicionar pergunta</Button>
        </Flex>
        <Flex justifyContent={'end'}>
            <Button onClick={() => nav(`${pathname.replace('Formulario', 'Aprovacao')}`)}
              rightIcon={<FaAngleRight />} marginLeft={'1rem'} size={'lg'} VarColor='Green2'
            >Próximo</Button>
        </Flex>
      </WhiteBox>
    </Body>
  )
}
